import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm$creditNote$fromOr, _vm$creditNote$fromOr2, _vm$creditNote$issuin, _vm$creditNote$fromOr3, _vm$creditNote$fromOr4;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_vm.isLoading ? [_c(VSkeletonLoader, {
    attrs: {
      type: "table-heading"
    }
  }), _c(VSkeletonLoader, {
    attrs: {
      type: "image"
    }
  }), _c(VSkeletonLoader, {
    attrs: {
      type: "table-row-divider@2"
    }
  })] : [_c("div", {
    staticClass: "split-sections"
  }, [_c("section", {
    staticClass: "--2-columns text-smaller"
  }, [_c("div", [_vm._m(0), _vm.creditNote.user ? _c("div", {
    domProps: {
      innerHTML: _vm._s(String.parseForVHtml(_vm.getFullNameUserHtml(_vm.creditNote.user)))
    }
  }) : _vm.creditNote.importer ? _c("div", [_vm._v(_vm._s(_vm.creditNote.importer.name))]) : _vm._e()]), _c("div", [_vm._m(1), _vm.creditNote.user ? _c("Address", {
    attrs: {
      baseModel: _vm.creditNote.user.billingAddress,
      listCountries: [_vm.creditNote.user.billingAddress.country],
      listStates: [_vm.creditNote.user.billingAddress.state],
      readOnly: true
    }
  }) : _vm.creditNote.importer ? _c("div", [_c("div", [_vm._v(_vm._s(_vm.creditNote.importer.addressLine1))]), _vm.creditNote.importer.addressLine2 ? _c("div", [_vm._v(" " + _vm._s(_vm.creditNote.importer.addressLine2) + " ")]) : _vm._e()]) : _vm._e()], 1)]), _c("section", {
    staticClass: "--2-columns"
  }, [_c("div", {
    staticClass: "force-new-row-after"
  }, [_c(VTextField, {
    attrs: {
      readonly: "",
      label: "Creation date",
      "hide-details": "auto"
    },
    model: {
      value: _vm.creditNote.creationDate,
      callback: function callback($$v) {
        _vm.$set(_vm.creditNote, "creationDate", $$v);
      },
      expression: "creditNote.creationDate"
    }
  })], 1), _vm.creditNote.isCmFrIssuing ? _c("div", [_c("div", {
    staticClass: "text-bold text-smaller"
  }, [_vm._v("C&M FR numbers")]), _c(VTextField, {
    staticClass: "half",
    attrs: {
      readonly: "",
      label: "Credit Note#",
      "hide-details": "auto"
    },
    model: {
      value: _vm.creditNote.numberLabel,
      callback: function callback($$v) {
        _vm.$set(_vm.creditNote, "numberLabel", $$v);
      },
      expression: "creditNote.numberLabel"
    }
  }), (_vm$creditNote$fromOr = _vm.creditNote.fromOrder) !== null && _vm$creditNote$fromOr !== void 0 && _vm$creditNote$fromOr.invoiceNumberLabel ? _c(VTextField, {
    attrs: {
      readonly: "",
      label: "From Invoice#",
      "hide-details": "auto"
    },
    model: {
      value: _vm.creditNote.fromOrder.invoiceNumberLabel,
      callback: function callback($$v) {
        _vm.$set(_vm.creditNote.fromOrder, "invoiceNumberLabel", $$v);
      },
      expression: "creditNote.fromOrder.invoiceNumberLabel"
    }
  }) : _vm._e(), _c("div", {
    staticClass: "flex items-baseline gap-2 mt-2"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn highlight --small-2",
    attrs: {
      loading: _vm.gettingFiles.isPending,
      rounded: true,
      title: "Download PDF"
    },
    on: {
      click: function click($event) {
        return _vm.openIssuingCmFrFile();
      }
    }
  }, [_c(VIcon, {
    staticClass: "far fa-file mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" C&M FR document ")], 1), (_vm$creditNote$fromOr2 = _vm.creditNote.fromOrder) !== null && _vm$creditNote$fromOr2 !== void 0 && _vm$creditNote$fromOr2.id ? _c(VBtn, {
    staticClass: "dfwa-btn --small-2",
    attrs: {
      rounded: "",
      to: _vm.toOrderDetails(_vm.creditNote.fromOrder.id)
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-external-link-alt mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" From order ")], 1) : _vm._e()], 1)], 1) : _vm._e(), ((_vm$creditNote$issuin = _vm.creditNote.issuingImporter) === null || _vm$creditNote$issuin === void 0 ? void 0 : _vm$creditNote$issuin.id) > 0 ? _c("div", [_c("div", {
    staticClass: "text-bold text-smaller"
  }, [_vm._v(_vm._s(_vm.creditNote.issuingImporter.name) + " numbers")]), _c(VTextField, {
    staticClass: "half",
    attrs: {
      readonly: "",
      label: "Credit Note#",
      "hide-details": "auto"
    },
    model: {
      value: _vm.creditNote.issuingImporterNumberLabel,
      callback: function callback($$v) {
        _vm.$set(_vm.creditNote, "issuingImporterNumberLabel", $$v);
      },
      expression: "creditNote.issuingImporterNumberLabel"
    }
  }), (_vm$creditNote$fromOr3 = _vm.creditNote.fromOrder) !== null && _vm$creditNote$fromOr3 !== void 0 && _vm$creditNote$fromOr3.importerInvoiceNumberLabel ? _c(VTextField, {
    attrs: {
      readonly: "",
      label: "From Invoice#",
      "hide-details": "auto"
    },
    model: {
      value: _vm.creditNote.fromOrder.importerInvoiceNumberLabel,
      callback: function callback($$v) {
        _vm.$set(_vm.creditNote.fromOrder, "importerInvoiceNumberLabel", $$v);
      },
      expression: "creditNote.fromOrder.importerInvoiceNumberLabel"
    }
  }) : _vm._e(), _c("div", {
    staticClass: "flex items-baseline gap-2 mt-2"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn highlight --small-2",
    attrs: {
      loading: _vm.gettingFiles.isPending,
      rounded: true,
      title: "Download PDF"
    },
    on: {
      click: function click($event) {
        return _vm.openIssuingImporterFile();
      }
    }
  }, [_c(VIcon, {
    staticClass: "far fa-file mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Importer document ")], 1), (_vm$creditNote$fromOr4 = _vm.creditNote.fromOrder) !== null && _vm$creditNote$fromOr4 !== void 0 && _vm$creditNote$fromOr4.id ? _c(VBtn, {
    staticClass: "dfwa-btn --small-2",
    attrs: {
      rounded: "",
      to: _vm.toOrderDetails(_vm.creditNote.fromOrder.id)
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-external-link-alt mr-1",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" From order ")], 1) : _vm._e()], 1)], 1) : _vm._e()]), _c("section", [_vm.creditNote.initialVatRate ? _c(VTextField, {
    staticClass: "half",
    attrs: {
      readonly: "",
      label: "VAT (%)",
      "hide-details": "auto"
    },
    model: {
      value: _vm.getVat,
      callback: function callback($$v) {
        _vm.getVat = $$v;
      },
      expression: "getVat"
    }
  }) : _vm._e(), _c(VTextField, {
    staticClass: "half",
    attrs: {
      readonly: "",
      label: "Currency",
      "hide-details": "auto"
    },
    model: {
      value: _vm.getCurrency,
      callback: function callback($$v) {
        _vm.getCurrency = $$v;
      },
      expression: "getCurrency"
    }
  }), _vm.creditNote.initialVatRate ? _c(VTextField, {
    staticClass: "half",
    attrs: {
      readonly: "",
      label: "Total amount excl. VAT",
      "hide-details": "auto"
    },
    model: {
      value: _vm.creditNote.totalAmountExVatCurrency,
      callback: function callback($$v) {
        _vm.$set(_vm.creditNote, "totalAmountExVatCurrency", $$v);
      },
      expression: "creditNote.totalAmountExVatCurrency"
    }
  }) : _vm._e(), _vm.creditNote.initialVatRate && _vm.creditNote.initialCurrency !== "EUR" ? _c(VTextField, {
    attrs: {
      readonly: "",
      label: "Total amount (€) excl. VAT",
      "hide-details": "auto"
    },
    model: {
      value: _vm.creditNote.totalAmountExVatEuro,
      callback: function callback($$v) {
        _vm.$set(_vm.creditNote, "totalAmountExVatEuro", $$v);
      },
      expression: "creditNote.totalAmountExVatEuro"
    }
  }) : _vm._e(), _c(VTextField, {
    staticClass: "half",
    attrs: {
      readonly: "",
      label: "Total amount",
      "hide-details": "auto"
    },
    model: {
      value: _vm.creditNote.totalAmountCurrency,
      callback: function callback($$v) {
        _vm.$set(_vm.creditNote, "totalAmountCurrency", $$v);
      },
      expression: "creditNote.totalAmountCurrency"
    }
  }), _vm.creditNote.initialCurrency !== "EUR" ? _c(VTextField, {
    staticClass: "mt-5",
    attrs: {
      readonly: "",
      label: "Total amount (€)",
      "hide-details": "auto"
    },
    model: {
      value: _vm.creditNote.totalAmountEuro,
      callback: function callback($$v) {
        _vm.$set(_vm.creditNote, "totalAmountEuro", $$v);
      },
      expression: "creditNote.totalAmountEuro"
    }
  }) : _vm._e()], 1), _vm.creditNote.extraDescription || _vm.creditNote.comment ? _c("section", [_vm.creditNote.extraDescription ? _c(VTextField, {
    staticClass: "full",
    attrs: {
      readonly: "",
      label: "Extra description",
      "hide-details": "auto"
    },
    model: {
      value: _vm.creditNote.extraDescription,
      callback: function callback($$v) {
        _vm.$set(_vm.creditNote, "extraDescription", $$v);
      },
      expression: "creditNote.extraDescription"
    }
  }) : _vm._e(), _vm.creditNote.comment ? _c(VTextarea, {
    staticClass: "full",
    attrs: {
      "no-resize": "",
      readonly: "",
      label: "Comment",
      "hide-details": "auto"
    },
    model: {
      value: _vm.creditNote.comment,
      callback: function callback($$v) {
        _vm.$set(_vm.creditNote, "comment", $$v);
      },
      expression: "creditNote.comment"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.creditNote.uses ? _c("section", [_c(VDataTable, {
    staticClass: "elevation-1 full",
    attrs: {
      headers: _vm.useHeaders,
      items: _vm.creditNote.uses,
      loading: _vm.isLoading,
      "hide-default-footer": "",
      "disable-pagination": ""
    },
    scopedSlots: _vm._u([{
      key: "top",
      fn: function fn() {
        return [_c(VToolbar, {
          attrs: {
            flat: ""
          }
        }, [_c(VToolbarTitle, [_vm._v("Use details")])], 1)];
      },
      proxy: true
    }, {
      key: "item.status",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [item.status === _vm.creditNoteUse.status.IN_PROGRESS ? _c("div", {
          staticClass: "badge neutral"
        }, [_vm._v(" In progress ")]) : item.status === _vm.creditNoteUse.status.APPLIED ? _c("div", {
          staticClass: "badge success"
        }, [_vm._v(" Applied on order ")]) : item.status === _vm.creditNoteUse.status.MANUAL_REFUND ? _c("div", {
          staticClass: "badge success"
        }, [_vm._v(" Refunded / Closed ")]) : _c("div", {
          staticClass: "badge danger"
        }, [_vm._v("Canceled")])];
      }
    }, {
      key: "item.note",
      fn: function fn(_ref2) {
        var _item$order, _item$order2;
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.note) + " "), (_item$order = item.order) !== null && _item$order !== void 0 && _item$order.id ? _c("router-link", {
          staticClass: "router-link ml-2",
          attrs: {
            to: _vm.toOrderDetails((_item$order2 = item.order) === null || _item$order2 === void 0 ? void 0 : _item$order2.id),
            target: "_blank",
            title: "Open order details"
          }
        }, [_c("i", {
          staticClass: "fas fa-external-link-alt"
        })]) : _vm._e()];
      }
    }, {
      key: "item.amountCurrency",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_vm._v(" " + _vm._s(_vm.formatPrice(item.amountCurrency)) + " " + _vm._s(_vm.getSymbolCurrency(item.currency)) + " ")];
      }
    }], null, true)
  })], 1) : _vm._e(), _c("section", [_c(VDataTable, {
    staticClass: "elevation-1 full",
    attrs: {
      headers: _vm.itemHeaders,
      items: _vm.creditNote.items,
      loading: _vm.isLoading,
      "hide-default-footer": "",
      "disable-pagination": ""
    },
    scopedSlots: _vm._u([{
      key: "top",
      fn: function fn() {
        return [_c(VToolbar, {
          attrs: {
            flat: ""
          }
        }, [_c(VToolbarTitle, [_vm._v("Item details")])], 1)];
      },
      proxy: true
    }, {
      key: "item.unitPriceCurrency",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [item.type === _vm.creditNoteItem.type.PRODUCT ? [_vm._v(" " + _vm._s(_vm.formatPrice(item.unitPriceCurrency + item.unitDefaultShippingCurrencyIncluded)) + " " + _vm._s(_vm.getSymbolCurrency(_vm.creditNote.initialCurrency)) + " ")] : item.type === _vm.creditNoteItem.type.SHIPPING ? [_vm._v("-")] : [_vm._v("-")]];
      }
    }, {
      key: "item.amount",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [item.type === _vm.creditNoteItem.type.PRODUCT ? [_vm._v(" " + _vm._s(_vm.formatPrice(item.amount + item.unitDefaultShippingCurrencyIncluded * item.quantity)) + " " + _vm._s(_vm.getSymbolCurrency(_vm.creditNote.initialCurrency)) + " ")] : item.type === _vm.creditNoteItem.type.SHIPPING ? [_vm._v(" " + _vm._s(_vm.formatPrice(item.amount - _vm.getTotalDefaultShippingCurrencyIncluded)) + " " + _vm._s(_vm.getSymbolCurrency(_vm.creditNote.initialCurrency)) + " ")] : [_vm._v(" " + _vm._s(_vm.formatPrice(item.amount)) + " " + _vm._s(_vm.getSymbolCurrency(_vm.creditNote.initialCurrency)) + " ")]];
      }
    }], null, true)
  }), _vm.creditNote.fromOrder ? _c("div", [_vm.creditNote.isReturnedToInventory ? _c("div", [_c("div", [_vm._v("The products have been picked-up and returned to the inventory")]), _c("div", [_c(VBtn, {
    staticClass: "dfwa-btn --small mt-1",
    attrs: {
      loading: _vm.exportingPdf.isPending,
      rounded: ""
    },
    on: {
      click: _vm.getPackingList
    }
  }, [_c(VIcon, {
    staticClass: "fa fa-file mr-3",
    attrs: {
      size: "0.65rem"
    }
  }), _vm._v(" Packing list ")], 1)], 1)]) : _c("div", [_vm._v("Financial-only credit")])]) : _vm._e()], 1)]), _c("div", {
    staticClass: "button-end-page-container"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn",
    attrs: {
      rounded: true
    },
    on: {
      click: _vm.exit
    }
  }, [_vm._v("Exit")])], 1)], _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 2);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-user"
  }), _vm._v(" Attached to ")]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "title-small"
  }, [_c("i", {
    staticClass: "fas fa-map-marked-alt"
  }), _vm._v(" Address ")]);
}];
render._withStripped = true;
export { render, staticRenderFns };